import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import { INVITATIONS_OUTPUT } from './topics';
import type { IInvitation } from './invitation';
import { invitationSchema } from './invitation';

export const UPDATED = 'INVITATIONS/UPDATED' as const;

export type IUpdatedPayload = IInvitation;

export interface IUpdatedAction {
  type: typeof UPDATED;
  payload: IUpdatedPayload;
}

export const updatedActionSchema = objectSchemaOf<IUpdatedAction>({
  type: Joi.string().required().valid(UPDATED),
  payload: invitationSchema.required(),
});

export const updated = actionCreator({
  type: UPDATED,
  topic: INVITATIONS_OUTPUT,
  schema: updatedActionSchema,
});
